export default "__VITE_ASSET__DkAbx7u1__"